import { ThemeProvider } from "@emotion/react";
import { createMuiTheme, Pagination } from "@mui/material"
import { color, palette, width } from "@mui/system";

const darkTheme = createMuiTheme({
    palette: {
        type: "dark",
    },
})



export const PaginationPage = ({ setPage, numOfPages = 100 }) => {
    const handlePagination = (page) => {
        setPage(page);
        window.scroll(0, 0);
    }
    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: 10,

            }}
        >
            <ThemeProvider theme={darkTheme}>
                <Pagination count={numOfPages} onChange={(e) => {
                    handlePagination(e.target.textContent)


                }}
                    hideNextButton
                    hidePrevButton
                    color="primary"
                />
            </ThemeProvider>
        </div>
    )
}